import {
  WebStorageStateStore,
  UserManager,
  type UserManagerSettings,
  type IdTokenClaims,
} from "oidc-client-ts";
import { useAuth, type AuthProviderProps } from "react-oidc-context";

export const userManagerSettings: UserManagerSettings = Object.freeze({
  authority: import.meta.env.VITE_AUTH_AUTHORITY!,
  client_id: import.meta.env.VITE_AUTH_CLIENT_ID!,
  redirect_uri: window.location.origin + "/callback",
  post_logout_redirect_uri: window.location.origin + "/logout",
  userStore: new WebStorageStateStore({
    store: window.localStorage,
    prefix: import.meta.env.VITE_AUTH_CLIENT_ID,
  }),
  response_type: "code",
  scope: "openid email profile api.public.scope"  ,
  automaticSilentRenew: true,
  includeIdTokenInSilentSignout: true,
});
export const userManager = new UserManager(userManagerSettings);

export const oidcConfig: AuthProviderProps = {
  userManager,
};

export function useUserSub(): string | undefined {
  const auth = useAuth();
  return auth.user?.profile?.sub;
}

export function useUserAttributes(): IdTokenClaims | undefined {
  const auth = useAuth();
  return auth?.user?.profile;
}
